let viewerInstance = null;
let layerManager = null;
export default {
  setViewer(viewer) {
    viewerInstance = viewer;
  },
  getViewer() {
    return viewerInstance;
  },
  setLayerManager(manager) {
    layerManager = manager;
  },
  getLayerManager() {
    return layerManager;
  },
  clear() {
    viewer = null;
    layerManager = null;
  }
};
